import { render } from "./HeroSection.vue?vue&type=template&id=05dddcf2"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__